import { ReportStudioElementMetadata } from '@/modules/ta/reportstudio/models/ReportStudioElementMetadata';
import { ShapeDesignOption } from '@/modules/ta/reportstudio/models/element/metadata/ShapeDesignOption';
import { ReportElementShapeTypes } from '@/modules/ta/reportstudio/reportstudio.constants';

export class ReportStudioShapeElementMetadata extends ReportStudioElementMetadata {
  /**
   * @type {string}
   */
  shape_type;

  constructor(model = {}) {
    super(model);
    this.design_options = new ShapeDesignOption(model.design_options);
    this.shape_type = model.shape_type ?? ReportElementShapeTypes.SQUARE;
  }
}
